export { default as injectIconFont } from './inject-icon-font';
export { default as injectWebFont } from './inject-web-font';
